import AppTheme from "@toothfairy/shared-ui/AppTheme";
import { useTranslation } from "react-i18next";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import Markdown from "react-native-markdown-display";
import { isLargeScreen } from "../Screens/MainViewContainer";
import ToothFairyButton from "./ToothFairyComponents/ToothFairyButton";
import ToothFairyLoadingPlaceholder from "./ToothFairyComponents/ToothFairyLoadingPlaceholder";
import ToothFairyModal from "./ToothFairyComponents/ToothFairyModal";

const PlanViewerModal = ({
  visible,
  setVisible,
  planContent,
  isLoading = false,
}) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();

  const markdownStyles = {
    body: {
      color: currentTheme?.theme?.font_color,
      fontSize: 14,
      lineHeight: 20,
    },
    heading1: {
      fontSize: 24,
      fontWeight: "bold",
      color: currentTheme?.theme?.primary,
      marginBottom: 16,
    },
    heading2: {
      fontSize: 18,
      fontWeight: "bold",
      color: currentTheme?.theme?.font_color,
      marginTop: 20,
      marginBottom: 12,
    },
    heading3: {
      fontSize: 16,
      fontWeight: "600",
      color: currentTheme?.theme?.font_color,
      marginTop: 16,
      marginBottom: 8,
    },
    paragraph: {
      marginBottom: 10,
    },
    listItem: {
      marginBottom: 5,
    },
    bullet_list: {
      marginLeft: 10,
    },
    strong: {
      fontWeight: "bold",
    },
    link: {
      color: currentTheme?.theme?.primary,
      textDecorationLine: "underline",
    },
    code_block: {
      backgroundColor: currentTheme?.theme?.transparent,
      paddingHorizontal: 0,
      borderRadius: 3,
      borderColor: currentTheme?.theme?.transparent,
      fontWeight: "bold",
      color: currentTheme?.theme?.font_color,
    },
    code_inline: {
      backgroundColor: currentTheme?.theme?.transparent,
      paddingHorizontal: 0,
      borderRadius: 3,
      borderColor: currentTheme?.theme?.transparent,
      fontWeight: "bold",
      color: currentTheme?.theme?.font_color,
    },
  };

  return (
    <ToothFairyModal
      modalStyle={{
        height: 500,
        width: "90%",
        maxWidth: isLargeScreen() ? 750 : 350,
        marginHorizontal: "auto",
        marginTop: "auto",
        marginBottom: "auto",
        margin: "auto",
      }}
      isModalOpen={visible}
      setIsModalOpen={setVisible}
      modalTitle={""}
      closeModal={() => {
        setVisible(false);
      }}
    >
      <View
        style={[
          styles.container,
          { backgroundColor: currentTheme?.theme?.backgroundColor },
        ]}
      >
        <ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
          {isLoading ? (
            <ToothFairyLoadingPlaceholder
              caption="messages.loadingPlan"
              style={{ position: "relative", minHeight: 200 }}
            />
          ) : planContent ? (
            <Markdown style={markdownStyles}>{planContent}</Markdown>
          ) : (
            <View style={styles.loadingContainer}>
              <Text
                style={[
                  styles.loadingText,
                  { color: currentTheme?.theme?.darkGrey },
                ]}
              >
                {t("NoPlanAvailable")}
              </Text>
            </View>
          )}
        </ScrollView>

        <View style={styles.footer}>
          <ToothFairyButton
            title={t("Close")}
            onPress={() => setVisible(false)}
            buttonStyle={styles.button}
            primary
          />
        </View>
      </View>
    </ToothFairyModal>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 12,
    padding: 24,
  },
  content: {
    flex: 1,
    marginBottom: 20,
  },
  loadingContainer: {
    padding: 40,
    alignItems: "center",
    justifyContent: "center",
  },
  loadingText: {
    fontSize: 16,
  },
  footer: {
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: "rgba(0,0,0,0.1)",
    alignItems: "center",
  },
  button: {
    paddingVertical: 12,
  },
});

export default PlanViewerModal;
